import { Navigate } from 'react-router-dom';
import React, { Fragment } from 'react';
import { useApi } from 'app/shared/contexts/api';

interface PrivateProps {
  redirectTo?: string;
  children: React.ReactNode;
}
export const Private = ({ redirectTo = '/error', children }: PrivateProps): JSX.Element | null => {
  const authToken = useApi('authToken');

  // No spinner and no user gate — the widgets render from building config, not the user,
  // so we never wait on (or fail on) the user fetch. authToken is the one critical input:
  // without it we can't call the API, so redirect to the error page.
  if (!authToken) {
    return <Navigate to={redirectTo} />;
  }

  // Wrapped in a React Fragment intentionally
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <Fragment>{children}</Fragment>;
};
